const types = {
  UPDATE_OPERATOR_BENEFIT: '@form/benefit/UPDATE',
  RESET_OPERATOR_BENEFIT: '@form/benefit/RESET_OPERATOR_BENEFIT',
};

export default types;
